<template>
  <!-- <template v-if="model_info">
    <div class="model_info item_block">
      <div class="report_section_basic_info_car_pic">
        <img :src="model_info.model_img" />
      </div>
      <CarInfoTable :car_info="model_info" />
    </div>
  </template> -->
  <div class="white_bg">
    <div class="tabs flex">
      <div
        :class="['tab', 'tab_1', first_node_show == 0 ? 'act' : '']"
        @click="changeFirstNode(0)"
      >
        <div class="tab_icon icon_function"></div>
        功能标杆分析
      </div>
      <div
        :class="['tab', 'tab_2', first_node_show == 1 ? 'act' : '']"
        @click="changeFirstNode(1)"
      >
        <div class="tab_icon icon_innovate"></div>
        创新标杆分析
      </div>
    </div>
    <!--================================ 功能标杆分析 ================================-->
    <div class="contents" v-show="first_node_show == 0">
      <div class="tab_items">
        <div
          :class="
            tab_select == 1
              ? 'tab_item cursor_pointer active'
              : 'tab_item cursor_pointer'
          "
          @click="changeSelect(1)"
        >
          一级标杆分析
        </div>
        <div
          :class="
            tab_select == 2
              ? 'tab_item cursor_pointer active'
              : 'tab_item cursor_pointer'
          "
          @click="changeSelect(2)"
        >
          二级标杆分析
        </div>
        <div class="add_model_btn" @click="addCompeting">
          <span class="addIcon"></span>
          <span class="addText">竞品</span>
        </div>
      </div>
      <!----------===== 功能 一级标杆分析  =====-------->
      <div class="tab_content" v-show="tab_select == 1">
        <!----------------- 一级标杆分析  ----------------->
        <div class="analyse_item">
          <div>
            <v-chart
              class="line_chart"
              :option="lineOptions"
              :style="{ width: '1100px', height: '350px' }"
              :loading="lineLoading"
              :loadingOptions="lineLoadingOptions"
              ref="lineChartDom"
              @click="echartsClick1"
            />
          </div>
        </div>
        <!----------------- 二级标杆分析  ----------------->
        <div class="analyse_item analyse_item1" v-show="levelTwoNodeShow">
          <!-- <div class="analyse_item_title">
            <span class="sanjiao"></span><span class="analyse_item_title_text"
              >{{ two_cur_node_name }}二级标杆分析</span><span class="hengxian"></span>
          </div> -->
          <NodeName
            :node_name="'标杆分析-'+two_cur_node_name"
          />
          <div class="line_chart_container">
            <v-chart
              class="line_chart"
              :option="lineOptions2"
              :style="{
                height: '300px',
                width: '1100px',
              }"
              :loading="lineLoading2"
              :loadingOptions="lineLoadingOptions"
              autoresize
              ref="lineChartDom2"
              @click="echartsClick"
            />
            <!-- <ChartComponent
              :node_id="l1_node_id_xn"
              :models="contrastList"
              @handel="l1_click_xn"
              :chartStyle="{
                width:'1100px',
                height:'300px'
              }"
            /> -->
          </div>
        </div>
        <!----------------- 二级标杆分析详情表格  ----------------->
        <div
          class="analyse_item analyse_item_table analyse_item_table1"
          v-show="two_node_detail_show"
        >
          <!-- <div class="analyse_item_title">
            <span class="sanjiao"></span
            ><span class="analyse_item_title_text"
              >{{ cur_node_name }}二级标杆分析</span
            ><span class="hengxian"></span>
          </div> -->
          <NodeName
            :node_name="'标杆分析-'+two_cur_node_name+'-'+cur_node_name"
          />
          <div class="tree_table_content" v-if="tree_table_data">
            <div
              :style="
                'width:' + [790, 1000, 1230][model_list.length - 1] + 'px;'
              "
            >
              <div class="model_list_box">
                <div
                  class="model_list_item model_list_attr"
                  style="width: 390px"
                >
                  车型信息
                </div>
                <template v-for="(item, ind) in model_list" :key="ind">
                  <div class="model_list_item" style="width: 230px">
                    <div class="model_attr">
                      {{
                        item.score_type == "own"
                          ? "我的车型"
                          : item.score_type == "compare"
                          ? "竞品最高"
                          : item.score_type == "max"
                          ? "行业最高"
                          : ""
                      }}
                    </div>
                    <div class="model_name">
                      {{ item.model_name }}
                    </div>
                  </div>
                </template>
                <div></div>
              </div>
              <el-table
                empty-text="暂无数据,敬请期待。"
                v-if="tree_table_data"
                v-loading="tree_table_loading"
                element-loading-text="计算得分中..."
                :data="tree_table_data"
                row-key="node_id"
                border
                :default-expand-all="true"
                :tree-props="{ children: 'child' }"
                :style="{
                  width: [770, 1000, 1230][model_list.length - 1] + 'px',
                }"
              >
                <el-table-column
                  :resizable="false"
                  label="评测项"
                  width="390"
                  :show-overflow-tooltip="true"
                >
                  <template #default="scope">
                    <span
                      class="level_tag"
                      v-if="
                        scope.row.is_leaf == 0 &&
                        scope.row.level > 0 &&
                        scope.row.level < 4
                      "
                      :style="{
                        background: ['#649FEB', '#65C57C', '#F29D65'][
                          scope.row.level - 1
                        ],
                      }"
                    >
                      {{
                        ["一", "二", "三", "四", "五", "六"][
                          scope.row.level - 1
                        ] + "级评测项"
                      }}
                    </span>
                    <span>
                      {{ scope.row.node_name || scope.row.name }}
                    </span>
                    <el-popover
                      v-if="
                        scope.row.child &&
                        Object.keys(scope.row.child).length == 0
                      "
                      :tabindex="-1"
                      placement="right"
                      :width="400"
                      trigger="hover"
                    >
                      <div class="rulePop" v-html="scope.row.node_desc"></div>
                      <template #reference>
                        <span
                          class="tip_icon"
                          @mouseenter="getRule(scope.row)"
                        ></span>
                      </template>
                    </el-popover>
                  </template>
                </el-table-column>
                <template v-for="(item, index) in model_list" :key="index">
                  <el-table-column :resizable="false" label="得分" width="230">
                    <template #default="scope">
                      <template
                        v-if="
                          scope.row.is_leaf == 0 &&
                          scope.row.level > 0 &&
                          scope.row.level < 4
                        "
                      >
                        <tree-table-item
                          :data="{
                            type: 1,
                            score: scope.row.score[index],
                            total_score: scope.row.total_score[index],
                            width: '190px',
                          }"
                        ></tree-table-item>
                      </template>
                      <template
                        v-else-if="
                          scope.row.score[index] > -1 &&
                          scope.row.total_score[index] > 0
                        "
                      >
                        <tree-table-item
                          :data="{
                            type: 2,
                            score: scope.row.score[index],
                            total_score: scope.row.total_score[index],
                            width: '190px',
                          }"
                        ></tree-table-item>
                      </template>
                    </template>
                  </el-table-column>
                </template>
                <el-table-column
                  :resizable="false"
                  label="详情"
                  width="150"
                  class-name="td_class"
                >
                  <template #default="scope">
                    <template v-if="scope.row.is_leaf == 0">
                      <!-- <span
                        class="appraise_one_tag"
                        v-if="scope.row.level == 1"
                        @click="getEvaluation(scope.row, '专家综合评价')"
                      >
                        专家综合评价
                      </span>
                      <span
                        class="appraise_two_tag"
                        v-else-if="scope.row.level == 2"
                        @click="getEvaluation(scope.row, '专家评价')"
                      >
                        专家评价
                      </span>
                      <span v-else> </span> -->
                      <span></span>
                    </template>
                    <span
                      class="detail_tag"
                      v-else
                      @click="
                        getDetail(scope.row);
                        showRuleDesc = false;
                      "
                    >
                      详情
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <!----------===== 功能 二级标杆分析  =====-------->
      <div class="tab_content" v-show="tab_select == 2">
        <!-- 二级标杆分析 -->
        <div class="analyse_item analyse_item_two flex_between">
          <div class="two_level_left">
            <div class="two_level_item" v-for="(item,ind) in two_node_tabs" :class="cur_two_act_id == item.node_id?'act':''" :key="ind" @click="cur_two_act_id = item.node_id;getAllTwoNode()">
              {{item.node_name}}
            </div>

          </div>
          <div class="two_level_right">
            <v-chart
              class="line_chart"
              :option="lineOptions3"
              :style="{
                height: '350px',
                width: '99%',
              }"
              :loading="lineLoading3"
              :loadingOptions="lineLoadingOptions"
              autoresize
              ref="lineChartDom3"
              @click="echartsClick2"
            />
          </div>
        </div>
        <!-- 二级标杆分析折线图 -->
        <!-- <div class="analyse_item">
          <div class="line_chart_container">
            <v-chart
              class="line_chart"
              :option="lineOptions3"
              :style="{
                height: '350px',
                width: '99%',
              }"
              :loading="lineLoading3"
              :loadingOptions="lineLoadingOptions"
              autoresize
              ref="lineChartDom3"
              @click="echartsClick2"
            />
            <div
              class="level1_label"
              :style="{ width: lineChartH2 ? lineChartH2 + 'px' : '100%' }"
            >
              <div class="flex" v-if="one_arr2 && one_arr2.length > 0">
                <template v-for="(item) of one_arr2" :key="item.node_id">
                  <div
                    v-if="item"
                    class="label"
                    :style="{
                      backgroundColor: '#fff',
                      padding: '0 .999984px',
                      width: getLevel1Width2(item.child_len),
                    }"
                  >
                    <div
                      :style="{
                        backgroundColor: '#eff6ff',
                        fontSize:'14px'
                      }"
                    >
                      {{ item.node_name }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div> -->
        <!--二级 二级标杆分析详情表格 -->
        <div
          class="analyse_item analyse_item_table analyse_item_table2"
          v-show="two_node_detail_show2"
        >
          <!-- <div class="analyse_item_title">
            <span class="sanjiao"></span
            ><span class="analyse_item_title_text"
              >{{ cur_node_name2 }}二级标杆分析</span
            ><span class="hengxian"></span>
          </div> -->
          <NodeName
            :node_name="'标杆分析-'+cur_node_name2"
          />
          <div class="tree_table_content" v-if="tree_table_data2">
            <div
              :style="
                'width:' + [790, 1000, 1230][model_list2.length - 1] + 'px;'
              "
            >
              <div class="model_list_box">
                <div
                  class="model_list_item model_list_attr"
                  style="width: 390px"
                >
                  车型信息
                </div>
                <template v-for="(item, ind) in model_list2" :key="ind">
                  <div class="model_list_item" style="width: 230px">
                    <div class="model_attr">
                      {{
                        item.score_type == "own"
                          ? "我的车型"
                          : item.score_type == "compare"
                          ? "竞品最高"
                          : item.score_type == "max"
                          ? "行业最高"
                          : ""
                      }}
                    </div>
                    <div class="model_name">
                      {{ item.model_name }}
                    </div>
                  </div>
                </template>
                <div></div>
              </div>
              <el-table
                empty-text="暂无数据,敬请期待。"
                v-if="tree_table_data2"
                v-loading="tree_table_loading2"
                element-loading-text="计算得分中..."
                :data="tree_table_data2"
                row-key="node_id"
                border
                :default-expand-all="true"
                :tree-props="{ children: 'child' }"
                :style="{
                  width: [770, 1000, 1230][model_list2.length - 1] + 'px',
                }"
              >
                <el-table-column
                  :resizable="false"
                  label="评测项"
                  width="390"
                  :show-overflow-tooltip="true"
                >
                  <template #default="scope">
                    <span
                      class="level_tag"
                      v-if="
                        scope.row.is_leaf == 0 &&
                        scope.row.level > 0 &&
                        scope.row.level < 4
                      "
                      :style="{
                        background: ['#649FEB', '#65C57C', '#F29D65'][
                          scope.row.level - 1
                        ],
                      }"
                    >
                      {{
                        ["一", "二", "三", "四", "五", "六"][
                          scope.row.level - 1
                        ] + "级评测项"
                      }}
                    </span>
                    <span>
                      {{ scope.row.node_name || scope.row.name }}
                    </span>
                    <el-popover
                      v-if="
                        scope.row.child &&
                        Object.keys(scope.row.child).length == 0
                      "
                      :tabindex="-1"
                      placement="right"
                      :width="400"
                      trigger="hover"
                    >
                      <div class="rulePop" v-html="scope.row.node_desc"></div>
                      <template #reference>
                        <span
                          class="tip_icon"
                          @mouseenter="getRule(scope.row)"
                        ></span>
                      </template>
                    </el-popover>
                  </template>
                </el-table-column>
                <template v-for="(item, index) in model_list2" :key="index">
                  <el-table-column :resizable="false" label="得分" width="230">
                    <template #default="scope">
                      <template
                        v-if="
                          scope.row.is_leaf == 0 &&
                          scope.row.level > 0 &&
                          scope.row.level < 4
                        "
                      >
                        <tree-table-item
                          :data="{
                            type: 1,
                            score: scope.row.score[index],
                            total_score: scope.row.total_score[index],
                            width: '190px',
                          }"
                        ></tree-table-item>
                      </template>
                      <template
                        v-else-if="
                          scope.row.score[index] > -1 &&
                          scope.row.total_score[index] > 0
                        "
                      >
                        <tree-table-item
                          :data="{
                            type: 2,
                            score: scope.row.score[index],
                            total_score: scope.row.total_score[index],
                            width: '190px',
                          }"
                        ></tree-table-item>
                      </template>
                    </template>
                  </el-table-column>
                </template>
                <el-table-column
                  :resizable="false"
                  label="详情"
                  width="150"
                  class-name="td_class"
                >
                  <template #default="scope">
                    <template v-if="scope.row.is_leaf == 0">
                      <!-- <span
                        class="appraise_one_tag"
                        v-if="scope.row.level == 1"
                        @click="getEvaluation(scope.row, '专家综合评价', 2)"
                      >
                        专家综合评价
                      </span>
                      <span
                          class="appraise_two_tag"
                          v-else-if="scope.row.level == 2"
                          @click="getEvaluation(scope.row, '专家评价', 2)"
                        >
                          专家评价
                        </span>
                      <span v-else> </span> -->
                      <span></span>
                    </template>
                    <span
                      class="detail_tag"
                      v-else
                      @click="
                        getDetail(scope.row, 2);
                        showRuleDesc = false;
                      "
                    >
                      详情
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--================================ 创新标杆分析 ================================-->
    <div class="contents" v-show="first_node_show == 1">
      <!-- 创新标杆分析折线图 -->
      <div class="analyse_item">
        <BarChartCompenent
          :loading="false"
          :lineOptions="lineOptions4"
          @handel="click_echart"
          :chartStyle="{
            'width':'1100px',
            'height':'300px'
          }"
        />
      </div>
      <!-- 创新标杆分析表格 -->
      <div
        class="analyse_item analyse_item_table analyse_item_table3"
        v-show="innovate_treetable_data"
      >
        <!-- <div class="analyse_item_title">
          <span class="sanjiao"></span
          ><span class="analyse_item_title_text"
            >{{ cur_node_name3 }}标杆分析</span
          ><span class="hengxian"></span>
        </div> -->
        <NodeName
          :node_name="'标杆分析-'+cur_node_name3"
        />
        <div class="tree_table_content" v-if="innovate_treetable_data">
          <div class="model_list_box">
            <div class="model_list_item model_list_attr" style="width: 390px">
              车型信息
            </div>
            <template v-for="(item, ind) in model_list3" :key="ind">
              <div class="model_list_item" style="width: 230px">
                <div class="model_attr">
                  {{
                    item.score_type == "own"
                      ? "我的车型"
                      : item.score_type == "compare"
                      ? "竞品最高"
                      : item.score_type == "max"
                      ? "行业最高"
                      : ""
                  }}
                </div>
                <div class="model_name">
                  {{ item.model_name }}
                </div>
              </div>
            </template>
            <div></div>
          </div>
          <el-table
            empty-text="暂无数据,敬请期待。"
            v-if="innovate_treetable_data"
            v-loading="innovate_treetable_loading"
            element-loading-text="计算得分中..."
            :data="innovate_treetable_data"
            :style="{
              width: [790, 1000, 1230][model_list3.length - 1] + 'px',
            }"
            row-key="node_id"
            border
            :default-expand-all="true"
            :tree-props="{ children: 'child' }"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              :resizable="false"
              label="评测项"
              width="390"
              :show-overflow-tooltip="true"
            >
              <template #default="scope">
                <span
                  class="level_tag"
                  v-if="
                    tab_select == 4
                      ? scope.row.node_id < 4
                      : scope.row.is_leaf == 0 &&
                        scope.row.level > 0 &&
                        scope.row.level < 4
                  "
                  :style="{
                    background:
                      tab_select == 4
                        ? '#649FEB'
                        : ['#649FEB', '#65C57C', '#F29D65'][
                            scope.row.level - 1
                          ],
                  }"
                >
                  {{
                    tab_select == 4
                      ? "创新类型"
                      : ["一", "二", "三", "四", "五", "六"][
                          scope.row.level - 1
                        ] + "级评测项"
                  }}
                </span>
                <span>
                  {{ scope.row.node_name || scope.row.name }}
                </span>
                <el-popover
                  v-if="
                    scope.row.child && Object.keys(scope.row.child).length == 0
                  "
                  :tabindex="-1"
                  placement="right"
                  :width="400"
                  trigger="hover"
                >
                  <div class="rulePop" v-html="scope.row.node_desc"></div>
                  <template #reference>
                    <span
                      class="tip_icon"
                      @mouseenter="getRule(scope.row)"
                    ></span>
                  </template>
                </el-popover>
              </template>
            </el-table-column>
            <template v-if="model_list3 && model_list3.length > 0">
              <template v-for="(item, index) in model_list3" :key="index">
                <el-table-column :resizable="false" label="得分" width="230">
                  <template #default="scope">
                    <template
                      v-if="
                        scope.row.node_id < 4 &&
                        scope.row.name.indexOf('创新') > -1
                      "
                    >
                      <tree-table-item
                        :data="{
                          type: 4,
                          score: scope.row.score[index],
                          total_score: scope.row.total_score[index],
                          width: '190px',
                        }"
                      ></tree-table-item>
                    </template>
                    <template
                      v-else-if="
                        scope.row.score[index] > -1 &&
                        scope.row.total_score[index] > 0
                      "
                    >
                      <tree-table-item
                        :data="{
                          type: 2,
                          score: scope.row.score[index],
                          total_score: scope.row.total_score[index],
                          width: '190px',
                        }"
                      ></tree-table-item>
                    </template>
                  </template>
                </el-table-column>
              </template>
            </template>

            <el-table-column
              :resizable="false"
              label="详情"
              width="150"
              class-name="td_class"
            >
              <template #default="scope">
                <template
                  v-if="
                    scope.row.score['0'] == 999 ||
                    scope.row.score['1'] == 999 ||
                    scope.row.score['2'] == 999
                  "
                >
                  <span class="detail_tag" style="color: #606266">
                    未开通权限
                  </span>
                </template>
                <template v-else>
                  <span
                    class="detail_tag"
                    v-if="!scope.row.child"
                    @click="getInnovateDetailInfo(scope.row)"
                  >
                    专家评价
                  </span>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>

  <!-- 测评详情表格弹窗 -->
  <el-drawer
    v-model="dialogVisible"
    :title="node_name"
    direction="rtl"
    :before-close="handleClose"
    :size="'auto'"
    modal-class="modal_transparent"
  >
    <div class="my_dialog" v-if="dialogVisible">
      <table class="detail_table" border="1">
        <tr class="detail_title">
          <td class="detail_attr">车型</td>
          <template
            v-for="(item, ind) in whitch_model == 1 ? model_list : model_list2"
            :key="ind"
          >
            <td class="detail_title_item" colspan="1">
              {{ item.model_name }}
            </td>
          </template>
        </tr>
        <tr class="detail_tr_item" v-show="showRuleDesc == true">
          <td class="detail_attr">
            标准
            <span id="triangle-up" @click="showRuleDesc = false"></span>
          </td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item.has_permission == 1">未开通权限</template>
              <template v-else>
                <div
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </template>
            </td>
          </template>
        </tr>
        <tr class="detail_tr_item">
          <!-- 背景色占位 -->
        </tr>
        <tr class="detail_tr_item" v-show="showRuleDesc == false">
          <td class="detail_attr">
            标准
            <span id="triangle-down" @click="showRuleDesc = true"></span>
          </td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item.has_permission == 1">未开通权限</template>
              <template v-else>
                <div
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 5px;
                  "
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </template>
            </td>
          </template>
        </tr>
        <tr class="detail_tr_item">
          <td class="detail_attr">
            <div>得分</div>
          </td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item.has_permission == 1">未开通权限</template>
              <template v-else>
                <div class="attr_box">
                  <!-- <div class="attr_node_name">
                  {{ node_name }}
                </div> -->
                  <div class="attr_node_score">
                    <span class="attr_node_score_num" style="color: #f00"
                      >{{
                        (item["1"] && item["1"].item_value_val) || 0
                      }}分</span
                    >
                  </div>
                </div>
              </template>
            </td>
          </template>
        </tr>
        <tr class="detail_tr_item">
          <td class="detail_attr">主观评价</td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item.has_permission == 1">未开通权限</template>
              <template v-else>
                <div
                  class="detail_val_text"
                  v-html="(item['2'] && item['2'].item_value_val) || '暂无'"
                ></div>
              </template>
            </td>
          </template>
        </tr>
        <!-- <tr class="detail_tr_item">
          <td class="detail_attr">客观信息</td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <div
                class="detail_val_text"
                v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
              ></div>
            </td>
          </template>
        </tr> -->
        <tr class="detail_tr_item">
          <td class="detail_attr">图片素材</td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item.has_permission == 1">未开通权限</template>
              <template v-else>
                <template v-if="item['4'] && item['4'].ext_info.length > 0">
                  <div class="detail_val_pic">
                    <div
                      class="detail_pic_left"
                      @click.stop="
                        previewImg(item['4'] && item['4'].ext_info, 'img')
                      "
                    >
                      <div class="detail_pic_left_img">
                        <img
                          :src="item['4'].ext_info[0].attach_value || ''"
                          alt="图片加载失败"
                        />
                        <span class="more_pic">{{
                          item["4"] && item["4"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看图片</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['4'] && item['4'].item_value_val"
                      v-html="item['4'] && item['4'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth('drive')" @click="downloadFn(item['4'] && item['4'].ext_info,model_list2[ind].model_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>
                  当前测试子节点本次未涉及图片素材
                </div>
              </template>
            </td>
          </template>
        </tr>
        <tr class="detail_tr_item">
          <td class="detail_attr">视频素材</td>
          <template v-for="(item, ind) in detail_list" :key="ind">
            <td class="detail_val">
              <template v-if="item.has_permission == 1">未开通权限</template>
              <template v-else>
                <template v-if="item['5'] && item['5'].ext_info.length > 0">
                  <div class="detail_val_video">
                    <div
                      class="detail_video_left"
                      @click.stop="
                        previewImg(item['5'] && item['5'].ext_info, 'video')
                      "
                    >
                      <div class="detail_pic_left_video">
                        <video
                          :src="item['5'].ext_info[0].attach_value"
                          :poster="
                            item['5'].ext_info[0].attach_value +
                            '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
                          "
                          preload="none"
                        ></video>
                        <span class="more_pic">{{
                          item["5"] && item["5"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看视频</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['5'] && item['5'].item_value_val"
                      v-html="item['5'] && item['5'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth('drive')" @click="downloadFn(item['5'] && item['5'].ext_info,model_list2[ind].model_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>
                  当前测试子节点本次未涉及视频素材
                </div>
              </template>
            </td>
          </template>
        </tr>
      </table>
    </div>
  </el-drawer>
  <!-- 专家评价表格弹窗 -->
  <el-drawer
    v-model="descDrawer"
    title=""
    direction="rtl"
    :before-close="handleClose"
    :size="'auto'"
    modal-class="modal_transparent"
  >
    <div class="one_evaluation_desc" v-if="evaluation_list.length == 1">
      <div class="one_desc_tit">
        {{ evaluation_list[0].node_name }}-专家综合评价
      </div>
      <div
        class="one_desc_desc"
        v-html="evaluation_list[0].node_value.content"
      ></div>
    </div>
    <div class="more_evaluation_desc" v-else>
      <table class="table3">
        <tr>
          <td
            v-for="(item, ind) in whitch_model == 1 ? model_list : model_list2"
            :key="ind"
          >
            <div class="table3_model_name">
              {{ item.model_name }}专家综合评价
            </div>
          </td>
        </tr>
        <tr>
          <td
            class="table_bd_left"
            v-for="(item, ind) in whitch_model == 1 ? model_list : model_list2"
            :key="ind"
          >
            <div class="table_title_text">评价主体</div>
          </td>
        </tr>
        <tr>
          <td
            class="table_bd_left"
            v-for="(item, ind) in whitch_model == 1 ? model_list : model_list2"
            :key="ind"
          >
            <div class="table3_model_desc">
              <div
                class="table3_model_content"
                v-if="
                  evaluation_list[ind] &&
                  evaluation_list[ind].node_value &&
                  evaluation_list[ind].node_value.content
                "
                v-html="evaluation_list[ind].node_value.content"
              ></div>
              <div
                class="table3_model_experts"
                v-if="evaluation_list[ind].node_value.evaluator"
              >
                评价专家:{{ evaluation_list[ind].node_value.evaluator }}
              </div>
              <div
                class="table3_model_time"
                v-if="evaluation_list[ind].node_value.evaluate_time"
              >
                {{
                  timestampToString(
                    evaluation_list[ind].node_value.evaluate_time
                  )
                }}
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </el-drawer>

  <!-- 创新专家评价 -->
  <el-drawer
    v-model="drawer"
    :title="innovate_detail_list_cur_type"
    direction="rtl"
    :before-close="handleClose"
    :size="'auto'"
    modal-class="modal_transparent"
  >
    <div class="my_dialog">
      <table class="detail_table2">
        <tr class="table_tit">
          <td
            class="table_tit_item"
            v-if="
              !(model_list3.length == 1 || innovate_detail_list.length == 1)
            "
          >
            车型信息
          </td>
          <!-- <td class="table_tit_item">对应二级功能指标</td>
          <td class="table_tit_item">创新分类</td> -->
          <td class="table_tit_item">创新项目</td>
          <td class="table_tit_item">创新维度评分</td>
          <td class="table_tit_item">综合得分</td>
          <td class="table_tit_item">图片素材</td>
          <td class="table_tit_item">视频素材</td>
          <td class="table_tit_item">创新项目主观评价</td>
        </tr>

        <template
          v-for="(list_item, list_ind) in innovate_detail_list"
          :key="list_ind"
        >
          <template v-for="(item, ind) in list_item" :key="ind">
            <tr class="table_tr">
              <template v-if="item">
                <td
                  class="table_tr_td"
                  v-if="
                    !(
                      model_list3.length == 1 ||
                      innovate_detail_list.length == 1
                    ) && ind == 0
                  "
                  :rowspan="list_item.length"
                >
                  <div class="td_model_info">
                    <div class="table_model_img" v-if="list_item.model_img">
                      <img
                        :src="list_item.model_img || ''"
                        alt="图片加载失败"
                      />
                    </div>
                    <div class="table_model_name">
                      {{ list_item.model_name }}
                    </div>
                  </div>
                </td>
                <!-- <td
                  class="table_tr_td table_tr_td_hebing"
                  v-if="item.hebing"
                  :rowspan="item.hebing"
                >
                  <div class="td_node_two td_text_bold">
                    {{ item.review_tree_name || "" }}
                  </div>
                </td>

                <td
                  class="table_tr_td table_tr_td_hebing"
                  v-if="list_ind == innovate_first_key && ind == 0"
                  rowspan="999"
                >
                  <div class="td_node_two td_text_bold">
                    {{innovate_detail_list_cur_type}}
                  </div>
                </td> -->

                <td class="table_tr_td">
                  <div class="td_node_name td_text_bold">
                    {{ item.node_name }}
                  </div>
                </td>
                <td class="table_tr_td">
                  <div class="td_score table_text">
                    <p>惊喜：{{ item.surprise_score || 0 }}分</p>
                    <p>实用：{{ item.practical_score || 0 }}分</p>
                    <p>独创：{{ item.originality_score || 0 }}分</p>
                  </div>
                </td>
                <td class="table_tr_td">
                  <div class="td_score_two">
                    {{ item.synthetical_score || 0 }}分
                  </div>
                </td>
                <td class="table_tr_td detail_val">
                  <template v-if="item.item['3'] && item.item['3'].ext_info.length > 0">
                    <div class="detail_val_pic">
                      <div
                        class="detail_pic_left"
                        @click.stop="
                          previewImg(
                            item.item['3'] && item.item['3'].ext_info,
                            'img'
                          )
                        "
                      >
                        <div class="detail_pic_left_img">
                          <img
                            :src="item.item['3'].ext_info[0].attach_value || ''"
                            alt="图片加载失败"
                          />
                          <span class="more_pic">{{
                            item.item["3"] && item.item["3"].ext_info.length
                          }}</span>
                        </div>
                        <div class="look_pic">点击查看图片</div>
                      </div>
                      <div
                        class="detail_pic_right detail_val_text"
                        v-if="item.item['3'] && item.item['3'].item_value_val"
                        v-html="item.item['3'] && item.item['3'].item_value_val"
                      ></div>
                    </div>
                    <div class="download_btn" v-if="store.getDownloadAuth('drive')" @click="downloadFn(item.item['3'] && item.item['3'].ext_info,list_item.model_name,innovate_detail_list_cur_type)"></div>
                  </template>
                  <div class="no_img" v-else>
                    当前测试子节点本次未涉及图片素材
                  </div>
                </td>
                <td class="table_tr_td detail_val">
                  <template v-if="item.item['4'] && item.item['4'].ext_info.length > 0">
                    <div class="detail_val_video">
                      <div
                        class="detail_video_left"
                        @click.stop="
                          previewImg(
                            item.item['4'] && item.item['4'].ext_info,
                            'video'
                          )
                        "
                      >
                        <div class="detail_pic_left_video">
                          <video
                            :src="item.item['4'].ext_info[0].attach_value"
                            :poster="
                              item.item['4'].ext_info[0].attach_value +
                              '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
                            "
                            preload="none"
                          ></video>
                          <span class="more_pic">{{
                            item.item["4"] && item.item["4"].ext_info.length
                          }}</span>
                        </div>
                        <div class="look_pic">点击查看视频</div>
                      </div>
                      <div
                        class="detail_pic_right detail_val_text"
                        v-if="item.item['4'] && item.item['4'].item_value_val"
                        v-html="item.item['4'] && item.item['4'].item_value_val"
                      ></div>
                    </div>
                    <div class="download_btn" v-if="store.getDownloadAuth('drive')" @click="downloadFn(item.item['4'] && item.item['4'].ext_info,list_item.model_name,innovate_detail_list_cur_type)"></div>
                  </template>
                  <div class="no_img" v-else>
                    当前测试子节点本次未涉及视频素材
                  </div>
                </td>

                <td class="table_tr_td">
                  <div class="td_evaluation table_text">
                    <template v-for="(p_item, p_ind) in item.item" :key="p_ind">
                      <p
                        v-if="
                          p_item.item_value_val &&
                          p_item.item_value_type != 4 &&
                          p_item.item_value_type != 5
                        "
                        v-html="p_item.item_value_val"
                      ></p>
                    </template>
                  </div>
                </td>
              </template>
            </tr>
          </template>
        </template>
      </table>
    </div>
  </el-drawer>

  <!-- 图片视频swiper -->
  <div class="my_swiper_dialog" v-if="swiperVisible">
    <div class="my_swiper_dialog_content">
      <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>

      <swiper :list="preview_list" :type="preview_type" />
    </div>
  </div>
  <!-- 侧边车型列表 -->
  <ModelList
    @changeModel="changeModel"
    :curid="query_model_id"
    from="first"
    route_type="drive"
  />

  <Competing ref="competingRef" @compareChange="compareChangeFn"/>
</template>

<script>
import { ref, getCurrentInstance } from "vue";
import {
  getEnergyType,
  timestampToString,
} from "@/components/common/js/common.js";
import { useRouter } from "vue-router";
import {
  getCarScore,
  getCarSummaryData,
  getCompareCarList,
  getNodeLineDetail,
  getNodeLineTwoDetail,
  getTestDetail,
  getInnovateLineDetail,
  getCarScoreInnovate,
  getInnovateDetail,
  getMyCar,
} from "@/api_drive";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart , BarChart } from "echarts/charts";
import {
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  MarkPointComponent,
  DataZoomComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  LineChart,
  BarChart,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  MarkPointComponent,
  DataZoomComponent
]);
import VChart from "vue-echarts";
import {
  ElTable,
  ElTableColumn,
  // ElProgress,
  // ElScrollbar,
  ElDrawer,
  ElMessage,
  ElPopover,
} from "element-plus";
import Swiper from "@/components/swiper/Swiper.vue";
import ModelList from "@/components/model/List.vue";
// import LineChartCompenent from "@/components/echarts/LineChart.vue";
import BarChartCompenent from "@/components/echarts/BarChart.vue";
import TreeTableItem from "@/components/common/views/treeTable/TreeTableItem.vue";
// import CarInfoTable from "@/components/common/views/carInfoTable.vue";
import NodeName from "@/components/common/views/NodeName.vue";
import Competing from "@/components/competing/competingDrive.vue";
// import ChartComponent from "@/components/echarts/BarChartComponent.vue";
import store from "@/store";
export default {
  name: "firstNode",
  components: {
    VChart,
    ElTable,
    ElTableColumn,
    // ElProgress,
    // ElScrollbar,
    ElDrawer,
    Swiper,
    ModelList,
    BarChartCompenent,
    ElPopover,
    TreeTableItem,
    // CarInfoTable,
    // ChartComponent
    NodeName,
    Competing
  },
  setup() {
    const showRuleDesc = ref(false);
    const model_info = ref(null);
    const router = useRouter();
    const { model_id } = router.currentRoute.value.query;
    const query_model_id = ref(model_id);
    const { appContext } = getCurrentInstance();
    let node_id = appContext.config.globalProperties.$levelId.drive_function;
    let echart_models1 = [];
    // let echart_models2 = [];

    const color_list = ['#69a8f0', '#AEDAAE', '#b0d8f5', '#5cbe85', '#f2d0a7', '#e1b0bb', '#EAC0EA', '#fac858', '#ee6666'];
    const lineLoading = ref(true);
    const lineLoadingOptions = ref({
      text: "Loading…",
      color: "#4ea397",
      maskColor: "rgba(255, 255, 255, 0.4)",
    });
    // 获取车型信息
    const getCarInfo = (id) => {
      getCarSummaryData({
        model_id: id || query_model_id.value,
        get_base: 1,
      }).then((res) => {
        model_info.value = res.data;
      });
    };
    const lineChartDom = ref(null);
    const own_model = ref(null);

    /*↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓一级标杆分析↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
    let two_nodes_models = {};
    // 获取一级标杆分析
    const getFirstNodeDetail = async (id) => {
      let competing_ids = [];
      await getCompareCarList().then((res) => {
        if (res && res.code && res.code == 200) {
          competing_ids = res.data.list.map((item) => {
            return item.model_id;
          });
        }
      });
      getNodeLineDetail({
        node_ids: node_id,
        own_model_id: id || query_model_id.value,
        compare_model_id: competing_ids.join("-"),
      }).then((res) => {
        if (res && res.code && res.code !== 200) {
          ElMessage({
            showClose: true,
            message: res.message || "出现错误！",
            type: "warning",
          });
        }
        /*
            横轴分类展示   车型分类展示   折线数值展示   
            lineName    legendName   lineValue
        */
        let lineName = [],
          legendName = [],
          lineValue = [],
          max_arr = [],
          min_arr = [],
          com_arr = [],
          own_arr = [],
          own_name = "",
          all_list = res.data[0].list;
        all_two_node.value = all_list.map((item) => {
          two_nodes_models[item.node_name] = {
            node_id:item.node_id,
            models:item.car_score.map(model_item=>{
              if(model_item.score_type!='min' && model_item.score_type!='own'){
                return model_item
              }
            }).filter(filter_item=>{
              return filter_item;
            })
          }
          return {
            node_name: item.node_name,
            node_id: item.node_id,
            // child_len:item.list.length
          };
        });
        // let all_two_node_id_arr = all_two_node.value.map((item) => {
        //   return item.node_id;
        // });
        // getAllTwoNode(all_two_node_id_arr);
        getAllTwoNode();
        all_list.forEach((item, ind) => {
          lineName.push({
            value: item.node_name,
          });
          item.car_score &&
            item.car_score.forEach((score_item) => {
              if (ind == 0) {
                if (score_item.score_type == "own") {
                  legendName[0]=({
                    name: score_item.model_name,
                    icon: "rect",
                  });
                }else if(score_item.score_type == "max"){
                  legendName[1]={
                    name:"行业最高",
                    icon: "rect",
                  }
                }else if(score_item.score_type == "compare"){
                  legendName[2]={
                    name:"竞品最高",
                    icon: "rect",
                  }
                }else if(score_item.score_type == "min"){
                  legendName[3]={
                    name:"行业最低",
                    icon: "rect",
                  }
                }
               
                if (score_item.score_type == "own") {
                  own_model.value = score_item;
                }
              }
              let score_percentage = parseFloat((score_item.score / item.total_score) * 100).toFixed(1);
              // Number(
              //   ((score_item.score / item.total_score) * 100).toFixed(2)
              // );
              let push_obj = {
                label: {
                  show: true,
                  position:'top',
                  color: "#404248",
                  fontSize: 10,
                  // formatter: () => {
                  //   return score_percentage + "%";
                  // },
                },
                value: score_percentage,
                set_y_data: {
                  ...score_item,
                  total_score: item.total_score,
                  y_node_id: item.node_id,
                  y_node_name: item.node_name,
                },
              };
              if (score_item.score_type == "max") {
                max_arr.push(push_obj);
              } else if (score_item.score_type == "min") {
                min_arr.push(push_obj);
              } else if (score_item.score_type == "compare") {
                com_arr.push(push_obj);
              } else if (score_item.score_type == "own") {
                own_arr.push(push_obj);
                if (!own_name) {
                  own_name = score_item.model_name;
                }
              }
            });
          // node_item.score_percentage = Number((node_item.score/node_item.total_score*100).toFixed(1))
        });
        if (own_arr.length > 0) {
          lineValue.push({
            name: own_name,
            animation: true,
            type: "bar",
            barWidth:25,
            emphasis: {
              focus: 'series'
            },
            data: own_arr,
          });
        }
        if (max_arr.length > 0) {
          lineValue.push({
            name: "行业最高",
            animation: true,
            type: "bar",
            barWidth:25,
            emphasis: {
              focus: 'series'
            },

            data: max_arr,
            // triggerLineEvent:true,
          });
        }
        
        if (com_arr.length > 0) {
          lineValue.push({
            name: "竞品最高",
            animation: true,
            type: "bar",
            barWidth:25,
            emphasis: {
              focus: 'series'
            },

            data: com_arr,
            triggerLineEvent: true,
          });
        }
        if (min_arr.length > 0) {
          lineValue.push({
            name: "行业最低",
            animation: true,
            type: "bar",
            barWidth:25,
            emphasis: {
              focus: 'series'
            },
          
            data: min_arr,
          });
        }
        legendName = legendName.filter(item=>{return item});
        setLineChartOptions(legendName, lineName, lineValue);
        // window.addContrast = addContrast;
      });
    };
    const lineOptions = ref(null);
    const setLineChartOptions = (legendName, lineName, lineValue) => {
      lineOptions.value = {
        color: ["#dd7488", "#4eb1d5", "#85d284", "#afafaf"],
        tooltip: {
          trigger: "axis",
          enterable: true,
          confine: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          padding: [7, 17, 17, 17],
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
          axisPointer: {
            type: 'shadow'
          },
          position: function (pos) {
            return [pos[0], pos[1]];
          },
          formatter: (params) => {
            let htmlStr = "";
            let htmlStrArr = [];
            let toolTipData = params
              .map((item) => {
                return item.data.set_y_data;
              })
              .filter((item) => {
                return item.score_type != "own";
              });
            toolTipData.forEach((item) => {
              let str_temp = `
                <div style="padding-top:9.999984px">
                    <div style="font-size:14.000016px;color:#e5e5e5">${
                      item.score_type == "max"
                        ? "行业最高"
                        : item.score_type == "min"
                        ? "行业最低"
                        : item.score_type == "compare"
                        ? "竞品最高"
                        : ""
                    }</div>
                    <div style="color:#fff"><strong>${
                      item.model_name
                    }</strong></div>
                    <div style="display:flex;justify-content:space-between;align-items:center;color:#B7B7B7;">
                        <div>${
                          parseFloat((item.score / item.total_score) * 100).toFixed(1)
                        }%</div>
                    </div>
                </div>
                `;

              item.score_type == "max"
                ? (htmlStrArr[0] = str_temp)
                : item.score_type == "compare"
                ? (htmlStrArr[1] = str_temp)
                : item.score_type == "min"
                ? (htmlStrArr[2] = str_temp)
                : "";
            });
            htmlStr = htmlStrArr.join("");
            return htmlStr;
          },
        },
        legend: {
          data: legendName,
          left: "center",
          top: "2%",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },
        grid: {
          show: true,
          backgroundColor: "rgba(250, 250, 250, .6)",
          borderColor: "rgba(255, 255, 255, 1)",
          left: 90,
          right: "4%",
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: lineName,
          axisLine: {
            lineStyle: {
              // color: "#b9c2da",
              width: "1", //坐标线的宽度
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            color: "#2192ff",
            fontSize: 14,
            padding: [0, 8],
            margin: 10,
            overflow: "breakAll",
            interval: 0,
          },
          offset: 10,
          nameTextStyle: {
            color: "#404248",
            fontSize: 16,
          },
          triggerEvent:true,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 30, 0, 0],
            formatter: "{value} %",
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
              width: "1",
            },
          },
          splitNumber: 5,
          min:0,
          max:100,
          // min: function (value) {
          //   return Math.floor(value.min / 10) * 10;
          // },
          // max: function (value) {
          //   return (Math.floor(value.max / 10) + 1) * 10 > 100
          //     ? 100
          //     : (Math.floor(value.max / 10) + 1) * 10;
          // },
          // interval:10
        },
        series: lineValue,
      };
      lineLoading.value = false;
    };
    /*↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑一级标杆分析↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/

    /*↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓二级标杆分析(添加对比车型)↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
    const levelTwoNodeShow = ref(false);
    let two_node = {};
    let two_model_arr = [];
    //  let two_nodes = [];
    let all_two_node = ref([]);
    const one_arr = ref([]);
    const two_arr = ref([]);
    const show_two_arr = ref([]);
    let show_model_ids_arr = [];

    const getTwoLineData = ()=>{
      let model_type = [{
        "model_id":query_model_id.value,
        "score_type":"own"
      }];
      show_model_ids_arr = [
        query_model_id.value,
        ...two_model_arr.map((item) => {
          model_type.push({
            "model_id":item.model_id,
            "score_type":item.score_type
          })
          return item.model_id;
        }),
      ];
      getNodeLineTwoDetail({
        node_ids: show_two_arr.value.join("-"),
        model_ids: show_model_ids_arr.join("-"),
        model_type:JSON.stringify(model_type)
      }).then((res) => {
        let data_list = res.data;
         /*
          横轴分类展示   车型分类展示   折线数值展示   
          lineName    legendName   lineValue
        */
        let lineName = [],
          legendName = [],
          lineValue = [];
        
        data_list.forEach((one_item)=>{
          one_item.list.forEach((two_item,two_ind)=>{
            lineName.push({
              value:two_item.node_name
            })
            two_arr.value.push({
              name: two_item.node_name,
              id: two_item.node_id,
            })
            two_item.car_score.forEach((score_item,score_ind)=>{
              if(two_ind==0){
              
                legendName.push({
                  name:score_item.model_name+(score_item.score_type == 'max'?'(行业最高)':score_item.score_type == 'compare'?'(竞品最高)':'(我的车型)'),
                  icon: "rect"
                })
                lineValue.push({
                  name: score_item.model_name+(score_item.score_type == 'max'?'(行业最高)':score_item.score_type == 'compare'?'(竞品最高)':'(我的车型)'),
                  animation: true,
                  type: "bar",
                  itemStyle: {
                    color: score_item.score_type == 'max'?'#4eb1d5':score_item.score_type == 'compare'?'#85d284':'#dd7488'
                  },
                  label: {
                    show: true,
                    position:'top',
                  },
                  barWidth:25,
                  triggerLineEvent: true,
                  data: [{
                    value: parseFloat((score_item.score / two_item.total_score) * 100).toFixed(1),
                    label: {
                      color: "#404248",
                      fontSize: 12,
                      formatter: () => {
                        return (
                          parseFloat((score_item.score / two_item.total_score) *100).toFixed(1)
                        );
                      },
                    },
                    emphasis: {
                      focus: 'series'
                    },
                  }],
                });
              }else{
                lineValue[score_ind]['data'].push({
                  value: parseFloat((score_item.score / two_item.total_score) * 100).toFixed(1),
                  label: {
                    color: "#404248",
                    fontSize: 12,
                    formatter: () => {
                      return (
                        parseFloat((score_item.score / two_item.total_score) *100).toFixed(1)
                      );
                    },
                  },
                  emphasis: {
                    focus: 'series'
                  },
                })
              }
            })
          })
        })
        console.log(legendName, lineName, lineValue)
        
        levelTwoNodeShow.value = true;
        legendName = legendName.filter(item=>{return item});
        setLineChartOptions2(legendName, lineName, lineValue);

      })

    }

    const two_cur_node_name = ref("");
    const echartsClick1 = (params)=>{
      if (params.componentType != "xAxis") {
        return ;
      }
      two_node = {
        node_name: params.value,
        node_id: two_nodes_models[params.value].node_id
      };
      two_cur_node_name.value = two_node.node_name;
      show_two_arr.value = [two_nodes_models[params.value].node_id];
      two_model_arr = two_nodes_models[params.value].models;
      echart_models1 = two_model_arr;
      lineChartDom2.value.clear();
      two_node_detail_show.value=false;
      tree_table_data.value=null;
      getTwoLineData();

    }


    const lineChartH = ref(0);
    const lineChartDom2 = ref(null);
    const lineLoading2 = ref(true);
    const lineOptions2 = ref(null);
    const setLineChartOptions2 = (
      legendName,
      lineName,
      lineValue,
    ) => {
      lineOptions2.value = {
        // color: color_list,
        
        color: ["#dd7488", "#4eb1d5", "#85d284", "#afafaf"],
        legend: {
          data: legendName,
          left: "center",
          top: "2%",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },
        grid: {
          show: true,
          backgroundColor: "rgba(250, 250, 250, .6)",
          borderColor: "rgba(255, 255, 255, 1)",
          left: 90,
          right: "4%",
        },
        xAxis: {
          triggerEvent: true,
          type: "category",
          boundaryGap: true,
          data: lineName,
          axisLine: {
            lineStyle: {
              // color: "#b9c2da",
              width: "1", //坐标线的宽度
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          nameTextStyle: {
            color: "#404248",
            fontSize: 16,
          },
          axisLabel: {
            color:"#2192ff",
            fontSize: 12,
            padding: [0, 8],
            margin: 10,
            overflow: "breakAll",
            interval: 0,
          },
          offset: 10,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 30, 0, 0],
            formatter: "{value} %",
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
            },
          },
          splitNumber: 5,
          min:0,
          max:100,
          // min: function (value) {
          //   return Math.floor(value.min / 10) * 10;
          // },
          // max: function (value) {
          //   return (Math.floor(value.max / 10) + 1) * 10 > 100
          //     ? 100
          //     : (Math.floor(value.max / 10) + 1) * 10;
          // },
          // interval:10
        },
        series: lineValue,
        tooltip: {
          trigger: "axis",
          enterable: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          padding: [7, 17, 17, 17],
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
          position: function (pos) {
            return [pos[0], pos[1]];
          },
          formatter: (params) => {
            let htmlStr = "";
            params.forEach((item) => {
              htmlStr += `
                  <div style="padding-top:9.999984px">
                      <div style="color:#f5f5f5"><strong>${item.seriesName}</strong></div>
                      <div style="display:flex;justify-content:space-between;align-items:center;color:#B7B7B7;">
                          <div>${item.value}%</div>
                      </div>
                  </div>
                  `;
            });
            return htmlStr;
          },
          axisPointer: {
            type: "shadow"
          }
        },
      };
      lineLoading2.value = false;
    };
    /*↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑二级标杆分析(添加对比车型)↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/

    /*↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓二级标杆分析↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
    // const lineChartH2 = ref(0);
    const lineLoading3 = ref(true);
    const lineChartDom3 = ref(null);
    const lineOptions3 = ref(null);
    let xAxis_all = [];
    let all_two_model_list = {};
    const cur_two_act_id = ref(5204);
    const two_node_tabs = [
      {
        node_name:'行车场景',
        node_id:5204,
      },
      {
        node_name:'高速领航辅助驾驶',
        node_id:5278,
      },
      {
        node_name:'自动泊车场景',
        node_id:5315,
      },
      {
        node_name:'DMS监测',
        node_id:5307,
      },
    ];
    const getAllTwoNode = async ()=>{
      let competing_ids = [];
      await getCompareCarList().then((res) => {
        if (res && res.code && res.code == 200) {
          competing_ids = res.data.list.map((item) => {
            return item.model_id;
          });
        }
      });
      getNodeLineDetail({
        node_ids: cur_two_act_id.value,
        own_model_id: query_model_id.value,
        compare_model_id: competing_ids.join("-"),
      }).then((res) => {
        xAxis_all = [];
        all_two_model_list = {};
        let data = res.data;
        let lineName = [],
          legendName = [],
          lineValue = [],
          max_arr = [],
          min_arr = [],
          com_arr = [],
          own_arr = [],
          own_name = "";
        data.forEach((first_item, first_ind) => {
          first_item.list.forEach((item, ind) => {
            lineName.push({
              value: item.node_name,
            });
            xAxis_all.push({
              node_name: item.node_name,
              node_id: item.node_id,
            });
            all_two_model_list[item.node_name] = item.car_score;
            item.car_score &&
              item.car_score.forEach((score_item) => {
                if (first_ind == 0 && ind == 0) {
                  if (score_item.score_type == "own") {
                    legendName[0]=({
                      name: score_item.model_name,
                      icon: "rect",
                    });
                  }else if(score_item.score_type == "max") {
                    legendName[1]=({
                      name: "行业最高",
                      icon: "rect",
                    });
                  }else if(score_item.score_type == "compare") {
                    legendName[2]=({
                      name: "竞品最高",
                      icon: "rect",
                    });
                  }else if(score_item.score_type == "min") {
                    legendName[3]=({
                      name: "行业最低",
                      icon: "rect",
                    });
                  }
                }
                let score_percentage = parseFloat((score_item.score / item.total_score) * 100).toFixed(1);
                // Number(
                //   ((score_item.score / item.total_score) * 100).toFixed(2)
                // );
                let push_obj = {
                  label: {
                    show:true,
                    color: "#404248",
                    fontSize: 10,
                    position:'top',
                    formatter: () => {
                      return score_percentage;
                    },
                  },
                  value: score_percentage,
                  set_y_data: {
                    ...score_item,
                    total_score: item.total_score,
                    y_node_id: item.node_id,
                  },
                };
                if (score_item.score_type == "max") {
                  max_arr.push(push_obj);
                } else if (score_item.score_type == "min") {
                  min_arr.push(push_obj);
                } else if (score_item.score_type == "compare") {
                  com_arr.push(push_obj);
                } else if (score_item.score_type == "own") {
                  own_arr.push(push_obj);
                  if (!own_name) {
                    own_name = score_item.model_name;
                  }
                }
              });
          });
        });
        // two_arr2.value = lineName;
        if (own_arr.length > 0) {
          lineValue.push({
            name: own_name,
            animation: true,
            type:'bar',
            barWidth:25,
            data: own_arr,
            // emphasis: {
            //   focus: 'series'
            // },
          });
        }
        if (max_arr.length > 0) {
          lineValue.push({
            name: "行业最高",
            animation: true,
            type:'bar',
            barWidth:25,
            data: max_arr,
            // emphasis: {
            //   focus: 'series'
            // },
          });
        }
        if (com_arr.length > 0) {
          lineValue.push({
            name: "竞品最高",
            animation: true,
            type:'bar',
            barWidth:25,
            data: com_arr,
            triggerLineEvent: true,
            // emphasis: {
            //   focus: 'series'
            // },
          });
        }
        if (min_arr.length > 0) {
          lineValue.push({
            name: "行业最低",
            animation: true,
            type:'bar',
            barWidth:25,
            data: min_arr,
            // emphasis: {
            //   focus: 'series'
            // },
          });
        }
       
        // color_list = ["#ff0000", "#008418", "#409eff", "#222222"];
        legendName = legendName.filter(item=>{return item});
        setLineChartOptions3(legendName, lineName, lineValue);
      });
    }
    const setLineChartOptions3 = (legendName, lineName, lineValue) => {
      lineOptions3.value = {
        // color: ["#ff0000", "#008418", "#222222", "#409eff"],
        color:["#dd7488", "#4eb1d5", "#85d284", "#afafaf"],
        tooltip: {
          trigger: "axis",
          enterable: true,
          confine: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          padding: [7, 17, 17, 17],
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
          position: function (pos) {
            return [pos[0], 40];
          },
          formatter: (params) => {
            let htmlStr = "";
            let htmlStrArr = [];
            let toolTipData = params
              .map((item) => {
                return item.data.set_y_data;
              })
              .filter((item) => {
                return item.score_type != "own";
              });
            toolTipData.forEach((item) => {
              let str_temp = `
                <div style="padding-top:9.999984px">
                    <div style="font-size:14.000016px;color:#e5e5e5">${
                      item.score_type == "max"
                        ? "行业最高"
                        : item.score_type == "min"
                        ? "行业最低"
                        : item.score_type == "compare"
                        ? "竞品最高"
                        : ""
                    }</div>
                    <div style="color:#f5f5f5"><strong>${
                      item.model_name
                    }</strong></div>
                    <div style="display:flex;justify-content:space-between;align-items:center;color:#B7B7B7;">
                        <div>${
                          parseFloat((item.score / item.total_score) *100).toFixed(1)
                        }%</div>
                    </div>
                </div>
              `;
              item.score_type == "max"
                ? (htmlStrArr[0] = str_temp)
                : item.score_type == "compare"
                ? (htmlStrArr[1] = str_temp)
                : item.score_type == "min"
                ? (htmlStrArr[2] = str_temp)
                : "";
            });
            htmlStr = htmlStrArr.join("");
            return htmlStr;
          },
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: legendName,
          left: "right",
          top: "2%",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },
        grid: {
          show: true,
          backgroundColor: "rgba(250, 250, 250, .6)",
          borderColor: "rgba(255, 255, 255, 1)",
          left: 90,
          right: 0,
          bottom:30
        },
        xAxis: {
          triggerEvent: true,
          type: "category",
          boundaryGap: true,
          data: lineName,
          axisLine: {
            lineStyle: {
              // color: "#b9c2da",
              width: "1", //坐标线的宽度
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            color:"#2192ff",
            fontSize: 14,
            padding: [0,0 ,0, 8],
            margin: 0,
            overflow: "breakAll",
            interval: 0,
          },
          offset: 10,
        },
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     start: 0,
        //     end: 15,
        //   },
        //   {
        //     type: 'slider'
        //   }
        // ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 2, 0, 0],
            formatter: "{value} %",
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
            },
          },
          splitNumber: 5,
          min:0,
          max:100,
          // min: function (value) {
          //   return Math.floor(value.min / 10) * 10;
          // },
          // max: function (value) {
          //   return (Math.floor(value.max / 10) + 1) * 10 > 100
          //     ? 100
          //     : (Math.floor(value.max / 10) + 1) * 10;
          // },
          // interval:10
        },
        series: lineValue,
      };
      lineLoading3.value = false;
    };
    const echartsClick2 = (params) => {
      let click_node_ind = params.event.topTarget.parent.anid.split("_")[1];
      if (params.componentType == "xAxis") {
        let node_info = {
          node_name: params.value,
          node_id: 0,
        };
        node_info.node_id = xAxis_all[click_node_ind].node_id;
        // xAxis_all.forEach((item) => {
        //   if (item.node_name == params.value) {
        //     node_info.node_id = item.node_id;
        //   }
        // });
        let ajax_model_arr = [];
        all_two_model_list[params.value].forEach((item) => {
          if (item.score_type == "own") {
            ajax_model_arr[0] = item;
          }
          if (item.score_type == "max") {
            ajax_model_arr[1] = item;
          }
          if (item.score_type == "compare") {
            ajax_model_arr[2] = item;
          }
        });
        getCarNodeData(node_info, ajax_model_arr, 2);
      }
    };
    getAllTwoNode();
 

    const show_next = () => {
      show_two_arr.value.push(
        all_two_node.value[show_two_arr.value.length].node_id
      );
      getTwoLineData();
    };
    const tree_table_data = ref(null);
    const tree_table_loading = ref([]);
    const tree_table_data2 = ref(null);
    const tree_table_loading2 = ref([]);
    const model_list = ref([]);
    const model_list2 = ref([]);
    const model_list3 = ref([]);
    const cur_node_name = ref("");
    const cur_node_name2 = ref("");
    const cur_node_name3 = ref("");
    const two_node_detail_show = ref(false);
    const two_node_detail_show2 = ref(false);
    // const two_node_detail_show3 = ref(false);
    const innovate_treetable_loading = ref(false);
    const innovate_treetable_data = ref(null);
    const lineloading4 = ref(false);
    const getCarNodeData = (node_info, model_arr, type) => {
      if (type && type == "创新") {
        innovate_treetable_loading.value = true;
        innovate_treetable_data.value = [];
        cur_node_name3.value = node_info.node_name;
        model_list3.value = model_arr;
        let promise_list = model_list3.value.map((item) => {
          return new Promise((resolve, reject) => {
            let reqParams = {
              report_id: item.report_id,
              model_id: item.model_id,
            };
            reqParams.type = node_info.node_id;
            reqParams.need_own = 1;
            getCarScoreInnovate(reqParams)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
        Promise.all(promise_list).then((res_list) => {
          var list = hebing(
            res_list.map((res) => {
              return res.data;
            }),
            true
          );
          list.forEach((childs) => {
            childs.child = chenggenb(childs.child, childs.name);
            // childs.child&&childs.child.forEach(child_item=>{
            //   if(Object.keys(child_item.child).length>0){
            //     child_item.child = chenggenb(child_item.child);
            //   }
            // })
          });
          if (list.length < 1) {
            list = [
              {
                child: [],
                name: node_info.node_name,
                node_id: node_info.node_id,
                score: {},
                total_score: {},
              },
            ];
          }
          innovate_treetable_loading.value = false;
          innovate_treetable_data.value = list;
          // two_node_detail_show3.value=true;
          lineloading4.value = true;
          goAnthor(".analyse_item_table3");
        });
      } else {
        if (type && type == 2) {
          tree_table_data2.value = [];
          tree_table_loading2.value = true;
          cur_node_name2.value = node_info.node_name;
          model_list2.value = model_arr;
        } else {
          tree_table_data.value = [];
          tree_table_loading.value = true;
          cur_node_name.value = node_info.node_name;
          model_list.value = model_arr;
        }
        const promise_list = model_arr.map((item) => {
          return new Promise((resolve, reject) => {
            getCarScore({
              report_id: item.report_id,
              model_id: item.model_id,
              node_id: node_info.node_id,
              need_own: 1,
            })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
        Promise.all(promise_list)
          .then((res_list) => {
            var list = hebing(
              res_list.map((res) => {
                return res.data.list;
              })
            );
            if (type) {
              tree_table_loading2.value = false;
              tree_table_data2.value = list;
              two_node_detail_show2.value = true;
              goAnthor(".analyse_item_table2");
            } else {
              tree_table_loading.value = false;
              tree_table_data.value = list;
              two_node_detail_show.value = true;
              goAnthor(".analyse_item_table1");
            }
          })
          .catch(() => {
            ElMessage({
              showClose: true,
              message: "分析数据拉取失败，请重试!",
              type: "warning",
            });
            return;
          });
      }
    };
    const echartsClick = (params) => {
      let click_node_ind = params.event.topTarget.parent.anid.split("_")[1];
      if (params.componentType == "xAxis") {
        let node_info = {
          node_name: params.value,
          node_id: 0,
        };
        node_info.node_id = two_arr.value[click_node_ind].id;
        // xAxis_all.forEach((item) => {
        //   if (item.node_name == params.value) {
        //     node_info.node_id = item.node_id;
        //   }
        // });
        let ajax_model_arr = [
          JSON.parse(JSON.stringify(own_model.value)),
        ].concat(echart_models1);
        getCarNodeData(node_info, ajax_model_arr);
      }
    };
    // const echartsClick2 = (params) => {
    //   let click_node_ind = params.event.topTarget.parent.anid.split("_")[1];
    //   if (params.componentType == "xAxis") {
    //     let node_info = {
    //       node_name: params.value,
    //       node_id: 0,
    //     };
    //     node_info.node_id = xAxis_all[click_node_ind].node_id;
    //     // xAxis_all.forEach((item) => {
    //     //   if (item.node_name == params.value) {
    //     //     node_info.node_id = item.node_id;
    //     //   }
    //     // });
    //     let ajax_model_arr = [];
    //     all_two_model_list[params.value].forEach((item) => {
    //       if (item.score_type == "own") {
    //         ajax_model_arr[0] = item;
    //       }
    //       if (item.score_type == "max") {
    //         ajax_model_arr[1] = item;
    //       }
    //       if (item.score_type == "compare") {
    //         ajax_model_arr[2] = item;
    //       }
    //     });
    //     getCarNodeData(node_info, ajax_model_arr, 2);
    //   }
    // };

    const randomColor = () => {
      return (
        "rgba(" +
        [
          Math.floor(Math.random() * 160),
          Math.floor(Math.random() * 160),
          Math.floor(Math.random() * 160),
        ].join(",") +
        ", 0.1)"
      );
    };
    const getLevel1Width = (len) => {
      return (len / two_arr.value.length) * 100 + "%";
    };
    // const getLevel1Width2 = (len) => {
    //   return (len / two_arr2.value.length) * 100 + "%";
    // };

    const descDrawer = ref(false);
    const node_name = ref("");
    const evaluation_type = ref("");
    const evaluation_list = ref([]);
    const whitch_model = ref(0);
    const getEvaluation = (row, type, witch) => {
      evaluation_type.value = type;
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
      let cur_list = [];
      if (witch) {
        cur_list = model_list2.value;
        whitch_model.value = 2;
      } else {
        cur_list = model_list.value;
        whitch_model.value = 1;
      }
      let promise_list2 = cur_list.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetail({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        evaluation_list.value = res_list.map((res) => {
          let item_value = {};
          if (res.data) {
            item_value = {
              node_name: res.data.node_name,
              node_value: res.data.node_value,
            };
          }
          return item_value;
        });
        descDrawer.value = true;
      });
    };
    // 详情弹窗数据展示列表
    const detail_list = ref([]);
    // 详情弹窗控制
    const dialogVisible = ref(false);
    //获取详情数据
    const getDetail = (row, witch) => {
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
      let cur_list = [];
      if (witch) {
        cur_list = model_list2.value;
        whitch_model.value = 2;
      } else {
        cur_list = model_list.value;
        whitch_model.value = 1;
      }
      let promise_list2 = cur_list.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetail({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        console.log(res_list);
        detail_list.value = res_list.map((res) => {
          let item_value = {
            has_permission: res.code == 503 ? 1 : 0,
          };
          if (res.data && res.data.item_value) {
            res.data.item_value.forEach((item) => {
              item_value[item.item_value_val_type] = item;
            });
            item_value["9"] = res.data["node_desc"];
          }
          console.log(item_value);
          return item_value;
        });
        console.log(detail_list.value);

        dialogVisible.value = true;
      });
    };

    const swiperVisible = ref(false);
    const preview_list = ref([]);
    const preview_type = ref("img");
    const previewImg = (list, type) => {
      preview_list.value = list;
      preview_type.value = type;
      swiperVisible.value = true;
    };

    const closeSwiperDialog = () => {
      document.querySelectorAll("video").forEach((item) => {
        item.pause();
      });
      swiperVisible.value = false;
    };
    const competingRef = ref(null);
    const addCompeting = () => {
      competingRef.value.competing_show = true;
      // router.push({
      //   path: "/competing",
      // });
    };

    const changeModel = (id) => {
      query_model_id.value = id;
      lineChartDom.value.clear();
      lineChartDom2.value.clear();
      lineChartDom3.value.clear();
      getCarInfo(id);
      getFirstNodeDetail(id);
      getInnovateLineData(id);
      tab_select.value = 1;
      two_model_arr = [];
      lineLoading.value = true;
      lineLoading2.value = true;
      // lineLoading3.value = true;
      lineloading4.value = true;
      levelTwoNodeShow.value = false;
      two_node_detail_show.value = false;
      two_node_detail_show2.value = false;
      // two_node_detail_show3.value = false;
    };
    // 标杆分析tab切换  功能 | 创新   first_node_show 0 功能  1 创新
    const first_node_show = ref(0);
    const tab_select = ref(1);

    const changeFirstNode = (ind) => {
      if (ind == 0) {
        innovate_treetable_data.value = null;
      } else {
        two_model_arr = [];
        tab_select.value = 1;
        two_node_detail_show2.value = false;
        tree_table_data2.value = null;
        levelTwoNodeShow.value = false;
        lineOptions2.value = null;
        two_node_detail_show.value = false;
        tree_table_data.value = null;
      }
      first_node_show.value = ind;
    };
    // 功能标杆下的tab切换
    const changeSelect = (ind) => {
      tab_select.value = ind;
      if (ind == 1) {
        two_node_detail_show2.value = false;
        tree_table_data2.value = null;
      } else {
        two_model_arr = [];
        levelTwoNodeShow.value = false;
        lineOptions2.value = null;
        two_node_detail_show.value = false;
        tree_table_data.value = null;
      }
    };

    // 获取创新指标分析
    const getInnovateLineData = (id) => {
      getInnovateLineDetail({
        own_model_id: id || query_model_id.value,
      })
        .then((res) => {
          if (res && res.code && res.code == 200) {
            generateLineChartsData({
              name: "创新",
              list: res.data,
            });
          } else {
            ElMessage({
              showClose: true,
              message: res.message || "出现错误！",
              type: "warning",
            });
          }
        })
        .catch((error) => {
          ElMessage({
            showClose: true,
            message: error || "出现错误！",
            type: "error",
          });
        });
    };

    let innovate_node_list = [];
    let innovate_all_node = {};
    const generateLineChartsData = (generate_obj) => {
      /*
          横轴分类展示   车型分类展示   折线数值展示   
          lineName    legendName   lineValue
      */
      let lineName = [],
        legendName = [],
        lineValue = [],
        max_arr = [],
        min_arr = [],
        com_arr = [],
        own_arr = [],
        own_name = "",
        all_list = generate_obj.list;

      let max_score = 0;

      innovate_node_list = [];

      all_list.forEach((item, ind) => {
        // X轴分类展示
        lineName.push({
          value: item.node_name,
        });

        innovate_node_list.push({
          node_name: item.node_name,
          node_id: item.node_id,
        });
        innovate_all_node[item.node_name] = item.car_score;
        let filter_own_item = item.car_score.filter((score_item) => {
          return score_item.score_type == "own";
        })[0];
        own_arr.push({
          label: {
            color: "#404248",
            fontSize: 12,
            formatter: () => {
              return (
                Number((filter_own_item && filter_own_item.score) || 0) +
                (generate_obj.name == "创新" ? "分" : "%")
              );
            },
          },
          value: Number(filter_own_item && filter_own_item.score),
          set_y_data: {
            ...filter_own_item,
            // total_score: item.total_score,
            y_node_id: item.node_id,
          },
        });

        let filter_max_item = item.car_score.filter((score_item) => {
          return score_item.score_type == "max";
        })[0];
        max_arr.push({
          label: {
            color: "#404248",
            fontSize: 12,
            formatter: () => {
              return (
                Number((filter_max_item && filter_max_item.score) || 0) +
                (generate_obj.name == "创新" ? "分" : "%")
              );
            },
          },
          value: Number(filter_max_item && filter_max_item.score),
          set_y_data: {
            ...filter_max_item,
            // total_score: item.total_score,
            y_node_id: item.node_id,
          },
        });

        let filter_min_item = item.car_score.filter((score_item) => {
          return score_item.score_type == "min";
        })[0];
        min_arr.push({
          label: {
            color: "#404248",
            fontSize: 12,
            formatter: () => {
              return (
                Number((filter_min_item && filter_min_item.score) || 0) +
                (generate_obj.name == "创新" ? "分" : "%")
              );
            },
          },
          value: Number(filter_min_item && filter_min_item.score),
          set_y_data: {
            ...filter_min_item,
            // total_score: item.total_score,
            y_node_id: item.node_id,
          },
        });

        let filter_com_item = item.car_score.filter((score_item) => {
          return score_item.score_type == "compare";
        })[0];
        com_arr.push({
          label: {
            color: "#404248",
            fontSize: 12,
            formatter: () => {
              return (
                Number((filter_com_item && filter_com_item.score) || 0) +
                (generate_obj.name == "创新" ? "分" : "%")
              );
            },
          },
          value: Number(filter_com_item && filter_com_item.score),
          set_y_data: {
            ...filter_com_item,
            // total_score: item.total_score,
            y_node_id: item.node_id,
          },
        });

        item.car_score &&
          item.car_score.forEach((score_item) => {
            if (max_score < Number(score_item.score)) {
              max_score = score_item.score;
            }
            if (score_item.score_type == "own" && !own_name) {
              own_name = score_item.model_name;
            }
            //   //这里有问题
            if (ind == 0) {
              //车型分类展示  我的车型展示车型名字  放最前面
              if (score_item.score_type == "own") {
                legendName[0]=({
                  name: score_item.model_name,
                  icon: "rect",
                });
              }else if (score_item.score_type == "max") {
                legendName[1]=({
                  name: "行业最高",
                  icon: "rect",
                });
              }else if (score_item.score_type == "compare") {
                legendName[2]=({
                  name: "竞品最高",
                  icon: "rect",
                });
              }else if (score_item.score_type == "min") {
                legendName[3]=({
                  name: "行业最低",
                  icon: "rect",
                });
              }
            }
          });
      });
      max_score = Math.ceil(max_score / 50) * 50;

      const lineValueObj = {
        name: "",
        animations: false,
        label: {
          show: true,
          position:'top',
        },
        type: "bar",
        smooth: false, //关键点，为true是不支持虚线，实线就用true
        lineStyle: {
          type: "solid",
          width: "1",
        },
        emphasis: {
          focus: 'series'
        },
        symbol: "circle",
        symbolSize: 8,
        barWidth:25,
        // barGap: 0, //柱子之间的距离
        data: [],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
      };
      if (own_arr.length > 0) {
        lineValue.push({
          ...lineValueObj,
          name: own_name,
          data: own_arr,
          lineStyle: {
            type: "solid",
            width: "1",
          },
        });
      }
      if (max_arr.length > 0) {
        lineValue.push({
          ...lineValueObj,
          name: "行业最高",
          data: max_arr,
        });
      }
      if (com_arr.length > 0) {
        lineValue.push({
          ...lineValueObj,
          name: "竞品最高",
          data: com_arr,
        });
      }
      if (min_arr.length > 0) {
        lineValue.push({
          ...lineValueObj,
          name: "行业最低",
          data: min_arr,
        });
      }
      legendName = legendName.filter(item=>{return item});
      setMyLineChartOptions({
        legendName,
        lineName,
        lineValue,
        type: "创新",
        max_score,
      });
    };
    const lineOptions4 = ref(null);
    const setMyLineChartOptions = (set_obj) => {
      let { legendName, lineName, lineValue, type, max_score } = set_obj;
      let basic_options = {
        // color: ["#ff0000", "#008418", "#222222", "#409eff"],
        color:color_list,
        tooltip: {
          trigger: "axis",
          enterable: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          padding: [7, 17, 17, 17],
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
          axisPointer: {
            type: "shadow"
          },
          position: function (pos) {
            return [pos[0], pos[1]];
          },
          formatter: (params) => {
            let htmlStr = "";
            let htmlStrArr = [];
            let toolTipData = params
              .map((item) => {
                return item.data.set_y_data;
              })
              .filter((item) => {
                return item.score_type != "own";
              });
            toolTipData.forEach((item) => {
              let str_temp = `
                <div style="padding-top:9.999984px">
                    <div style="font-size:14.000016px;color:#e5e5e5">${
                      item.score_type == "max"
                        ? "行业最高"
                        : item.score_type == "min"
                        ? "行业最低"
                        : item.score_type == "compare"
                        ? "竞品最高"
                        : ""
                    }</div>
                    <div style="color:#f5f5f5"><strong>${
                      item.model_name
                    }</strong></div>
                    <div style="display:flex;justify-content:space-between;align-items:center;color:#B7B7B7;">
                        <div>${Number(item.score)}分</div>
                    </div>
                </div>
                `;
              item.score_type == "max"
                ? (htmlStrArr[0] = str_temp)
                : item.score_type == "compare"
                ? (htmlStrArr[1] = str_temp)
                : item.score_type == "min"
                ? (htmlStrArr[2] = str_temp)
                : "";
            });
            htmlStr = htmlStrArr.join("");
            return htmlStr;
          },
        },
        legend: {
          data: legendName,
          left: "center",
          top: "2%",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },
        grid: {
                    show: true,
                    backgroundColor: "rgba(250, 250, 250, .6)",
                    borderColor: "rgba(255, 255, 255, 1)",
          left: 90,
          right: 90,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: lineName,
          axisLine: {
            lineStyle: {
              // color: "#b9c2da",
              width: "1", //坐标线的宽度
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            color:"#2192ff",
            fontSize: 12,
            padding: [0, 8],
            margin: 10,
            overflow: "breakAll",
            interval: 0,
          },
          offset: 10,
          triggerEvent: true,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 30, 0, 0],
            formatter: "{value}" + (type == "创新" ? "" : "%"),
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
            },
          },
          splitNumber: 5,
          min: 0,
          max: function (value) {
            return type == "创新"
              ? max_score
              : (Math.floor(value.max / 10) + 1) * 10 > 100
              ? 100
              : (Math.floor(value.max / 10) + 1) * 10;
          },
          // interval:10
        },
        series: lineValue,
      };
      if (type == "创新") {
        lineOptions4.value = {
          ...basic_options,
        };
      }
    };

    const click_echart = (click_data) => {
      let { params } = click_data;
      if (params.componentType == "xAxis") {
        let node_info = {
          node_name: params.value,
          node_id: 0,
        };
        innovate_node_list.forEach((item) => {
          if (item.node_name == params.value) {
            node_info.node_id = item.node_id;
          }
        });
        let ajax_model_arr = [];
        innovate_all_node[params.value].forEach((item) => {
          if (item.score_type == "own") {
            ajax_model_arr[0] = item;
          }
          if (item.score_type == "max") {
            ajax_model_arr[1] = item;
          }
          if (item.score_type == "compare") {
            ajax_model_arr[2] = item;
          }
        });
        getCarNodeData(node_info, ajax_model_arr, "创新");
      }
    };

    const objectSpanMethod = ({ row, columnIndex }) => {
      if (columnIndex === model_list3.value.length + 1) {
        if (!("child" in row)) {
          if (row.set_arr && row.set_arr.length) {
            return {
              rowspan: row.set_arr.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 1,
            };
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    };
    const drawer = ref(false);
    // 创新数据列表
    const innovate_detail_list = ref([]);
    const innovate_detail_list_cur_type = ref("");
    const innovate_first_key = ref(0);
    //获取创新项目详情数据
    const getInnovateDetailInfo = (row) => {
      innovate_detail_list_cur_type.value = row.parent_name;
      let node_id = row.set_arr.join("-") || row.id;
      let new_set_model_list = model_list3.value;
      const resp = new Map();
      new_set_model_list = new_set_model_list.filter(
        (new_set_model_list) =>
          !resp.has(new_set_model_list.model_id) &&
          resp.set(new_set_model_list.model_id, 1)
      );
      let promise_list3 = new_set_model_list.map((item) => {
        return new Promise((resolve, reject) => {
          getInnovateDetail({
            report_id: item.report_id,
            model_id: item.model_id,
            node_ids: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list3).then((res_list) => {
        let set_ind = 0;
        let set_add = 1;
        let prev_review_tree_name = "";
        innovate_detail_list.value = res_list
          .map((res, ind) => {
            let item_value = {};
            if (res.data && res.data.length) {
              item_value = res.data;
              item_value.model_name = model_list3.value[ind].model_name;
              item_value.model_id = model_list3.value[ind].model_id;
              item_value.model_img = model_list3.value[ind].model_img;
              res.data = res.data.map((item, index) => {
                let item_item_val = {};
                item.item.forEach((item_item) => {
                  item_item_val[item_item.item_value_type] = item_item;
                });
                item.item = item_item_val;
                if (item.review_tree_name != prev_review_tree_name) {
                  prev_review_tree_name = item.review_tree_name;
                  res.data[set_ind].hebing = set_add;
                  set_ind = index;
                  set_add = 1;
                } else {
                  item.hebing = 0;
                  set_add++;
                }
                return item;
              });
              res.data[set_ind].hebing = set_add;
              return item_value;
            } else {
              item_value = null;
            }
          })
          .filter((item) => {
            return item;
          });
        for (let key in innovate_detail_list.value) {
          if (innovate_detail_list.value[key] != null) {
            innovate_first_key.value = key;
            break;
          }
        }
        drawer.value = true;
        // dialogVisible.value= true;
      });
    };

    if (query_model_id.value) {
      getCarInfo();
      getFirstNodeDetail();
      getInnovateLineData();
    } else {
      getMyCar().then((res) => {
        if (
          res &&
          res.code &&
          res.data &&
          res.data.list &&
          res.data.list.length > 0
        ) {
          query_model_id.value = res.data.list[0].model_id;
          let cur_path = router.currentRoute.value.path;
          router.replace({
            path: cur_path,
            query: {
              model_id: res.data.list[0].model_id,
            },
          });
          getCarInfo();
          getFirstNodeDetail();
          getInnovateLineData();
        } else {
          ElMessage({
            showClose: true,
            message: res.message || "出现错误！",
            type: "warning",
          });
        }
      });
    }

    const compareChangeFn = ()=>{
      lineChartDom.value.clear();
      lineChartDom2.value.clear();
      lineChartDom3.value.clear();
      tab_select.value = 1;
      two_model_arr = [];
      lineLoading.value = true;
      lineLoading2.value = true;
      // lineLoading3.value = true;
      lineloading4.value = true;
      levelTwoNodeShow.value = false;
      two_node_detail_show.value = false;
      two_node_detail_show2.value = false;
      getCarInfo();
      getFirstNodeDetail();
      getInnovateLineData();
    }


    /*---------表格合并单元格---------*/
    function chenggenb(list, parent_name) {
      let set_ind = 0,
        set_arr = [],
        col_ind = 0;
      list = JSON.parse(JSON.stringify(list));
      list.forEach((row_item, row_ind) => {
        for (let i = 0; i < model_list3.value.length; i++) {
          if (row_item.score[i] > -1) {
            //如果有分数，并且和上一次的col_ind相等，就往set_arr里面push(row_item.node_id),
            //          不相等的话，就改变col_ind的值 并且重置新的set_arr= [row_item.node_id];
            //              当前下标小于col_ind 说明要重置新的set_arr= [row_item.node_id]
            if (i != col_ind) {
              list[set_ind]["set_arr"] = set_arr;
              list[set_ind]["parent_name"] = parent_name;
              set_arr = [];
              set_arr.push(row_item.node_id);
              set_ind = row_ind;
              col_ind = i;
              break;
            } else {
              set_arr.push(row_item.node_id);
              break;
            }
          }
          if (!(row_item.score[i] > -1) && i == model_list3.value.length - 1) {
            list[set_ind]["set_arr"] = set_arr;
            list[set_ind]["parent_name"] = parent_name;
            set_arr = [];
            set_ind = row_ind;
            col_ind = -1;
          }
        }
        if (row_ind == list.length - 1) {
          list[set_ind]["set_arr"] = set_arr;
          list[set_ind]["parent_name"] = parent_name;
        }
      });
      return list;
    }
    /*---------表格合并单元格---------*/

    /*---------合并树数据---------*/
    let scoreMap = {},
      childMap = {},
      nodeMap = {},
      count = 0;
    function hebing(data, is_cx) {
      count = data.length;
      let listMap = {};
      for (let k in data) {
        let list = data[k];
        for (let dd in list) {
          let d = JSON.parse(JSON.stringify(list[dd]));
          listMap[d["node_id"]] = mapList(d, k);
          setScoreMap(d["node_id"], d["total_score"], d["score"], k);
          nodeMap[d["node_id"]] = d;
        }
      }
      let tmpList = [];
      Object.values(listMap).forEach((l) => {
        l["total_score"] = fillArray(scoreMap[l["node_id"]]["total_score"]);
        l["score"] = fillArray(scoreMap[l["node_id"]]["score"]);
        tmpList.push(l);
      });
      let tree_list = rebuild(tmpList);
      scoreMap = {};
      childMap = {};
      nodeMap = {};
      count = 0;

      if (!is_cx) {
        let newMap = {};
        let result_list = [];
        for (let ti in tree_list) {
          newMap[tree_list[ti]["node_id"]] = tree_list[ti];
        }
        for (let di in data[0]) {
          result_list.push(newMap[data[0][di]["node_id"]]);
        }
        return result_list;
      } else {
        return tree_list;
      }
    }
    function rebuild(list) {
      let exitsArr = {};
      let newArr = Array();
      for (let key in list) {
        let l = list[key];
        if (!exitsArr[l["node_id"]]) {
          exitsArr[l["node_id"]] = true;
          if (childMap[l["node_id"]]) {
            let childList = [];
            for (let ckey in childMap[l["node_id"]]) {
              let c = childMap[l["node_id"]][ckey];
              let child = nodeMap[c];
              child["total_score"] = fillArray(
                scoreMap[child["node_id"]]["total_score"]
              );
              child["score"] = fillArray(scoreMap[child["node_id"]]["score"]);
              childList.push(child);
            }
            l["child"] = rebuild(childList);
          }
          newArr.push(l);
        }
      }
      return newArr;
    }
    function fillArray(arr) {
      for (let i = 0; i < count; i++) {
        if (typeof arr[i] == "undefined") {
          arr[i] = -1;
        }
      }
      return arr;
    }
    function mapList(list2, k) {
      let childlist2 = list2["child"];
      if (!childlist2) {
        return;
      }
      list2["child"] = {};
      if (childlist2.length > 0 || Object.keys(childlist2).length > 0) {
        for (let k1 in childlist2) {
          let child = childlist2[k1];
          if (
            !childMap[list2["node_id"]] ||
            childMap[list2["node_id"]].indexOf(child["node_id"]) == -1
          ) {
            if (!childMap[list2["node_id"]]) {
              childMap[list2["node_id"]] = [];
            }
            childMap[list2["node_id"]].push(child["node_id"]);
          }
          setScoreMap(
            child["node_id"],
            child["total_score"],
            child["score"],
            k
          );
          list2["child"] = {};
          list2["child"][child["node_id"] + ""] = mapList(child, k);
          nodeMap[child["node_id"]] = child;
        }
      } else {
        setScoreMap(list2["node_id"], list2["total_score"], list2["score"], k);
      }
      return list2;
    }
    function setScoreMap(node_id, total_score, score, k) {
      if (!scoreMap[node_id]) {
        scoreMap[node_id] = {};
      }
      if (!scoreMap[node_id]["total_score"]) {
        scoreMap[node_id]["total_score"] = {};
      }
      if (!scoreMap[node_id]["score"]) {
        scoreMap[node_id]["score"] = {};
      }
      scoreMap[node_id]["total_score"][k] = total_score;
      scoreMap[node_id]["score"][k] = score;
    }
    /*---------合并树数据---------*/

    const getRule = (row) => {
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
      model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetail({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              row.node_desc = res.data.node_desc;
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
    };

    const goAnthor = (selector) => {
      setTimeout(() => {
        const height = document.querySelector(selector).offsetTop;
        const container = document.querySelector(".el-main");
        container.scrollTo({
          top: selector == ".analyse_item_table3" ? height - 150 : height + 170,
          behavior: "smooth",
        });
      }, 100);
    };

    const downloadFn = (list,model_name,node_name)=>{
      store.addDownload(list,model_name,node_name);
      ElMessage.success("已添加到下载队列中")
    }

    return {
      getRule,
      model_info,
      getCarInfo,
      getEnergyType,
      lineLoadingOptions,
      lineLoading,
      lineLoading2,
      lineOptions,
      lineOptions2,
      timestampToString,
      lineChartDom,
      lineChartDom2,
      lineChartDom3,
      lineChartH,
      echartsClick,
      // echartsClick2,
      // addContrast,
      randomColor,
      one_arr,
      two_arr,
      all_two_node,
      getLevel1Width,
      show_next,
      tab_select,
      changeSelect,
      levelTwoNodeShow,
      // lineChartH2,
      // lineLoading3,
      // lineOptions3,
      // one_arr2,
      // two_arr2,
      // getLevel1Width2,
      tree_table_data,
      tree_table_data2,
      tree_table_loading,
      tree_table_loading2,
      model_list,
      model_list2,
      model_list3,
      two_node_detail_show,
      two_node_detail_show2,
      // two_node_detail_show3,
      getEvaluation,
      getDetail,
      node_name,
      evaluation_type,
      evaluation_list,
      descDrawer,
      dialogVisible,
      detail_list,
      preview_list,
      preview_type,
      previewImg,
      swiperVisible,
      closeSwiperDialog,
      addCompeting,
      cur_node_name,
      cur_node_name2,
      cur_node_name3,
      two_cur_node_name,
      whitch_model,
      changeModel,
      query_model_id,
      changeFirstNode,
      first_node_show,
      lineOptions4,
      click_echart,
      innovate_treetable_loading,
      innovate_treetable_data,
      objectSpanMethod,
      drawer,
      innovate_detail_list,
      getInnovateDetailInfo,
      lineloading4,
      showRuleDesc,
      innovate_detail_list_cur_type,
      innovate_first_key,
      competingRef,
      compareChangeFn,
      echartsClick1,

      lineOptions3,
      cur_two_act_id,
      two_node_tabs,
      getAllTwoNode,
      echartsClick2,

      downloadFn,
      store
    };
  },
};
</script>
<style>
.el-popover.el-popper {
  background: #ffffff;
  box-shadow: 0px 1px 9px 0px rgba(107, 148, 199, 0.5);
  border-radius: 8px;
}
</style>
<style lang="less" scoped>
#triangle-up {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 10px solid;
}
#triangle-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid;
}
.rulePop {
  white-space: break-spaces;
}
.tip_icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/c33656821a1100392efd965678caf39d.png)
    no-repeat center bottom;
  background-size: 17px 17px;
  margin-left: 10px;
}
.model_info {
  width: 1200px;
  background: #ffffff;
  border-radius: 4px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  .report_section_basic_info_car_pic {
    width: 180px;
    height: 98px;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.white_bg {
  padding-top: 30px;
  border-radius:10px;
  display: inline-block;
  min-width: 1090px;
}
.tabs {
  width:1090px;
  height: 42px;
  margin: 0 50px 0;
  border-bottom: 1px solid #d4d4d4;
  .tab {
    cursor: pointer;
    width: 185px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-size: 17px;
    color: #0e0a31;
    &.act {
      font-weight: bold;
      border-bottom: solid 2px #1fbcbf;
    }
  }
}
.analyse_item {
  margin-bottom: 30px;
  &.analyse_item_two{
    width:1090px;
  }
  &.analyse_item_table {
    min-height: 95vh;
  }
  h2 {
    position: relative;
    // padding-left: 30.999984px;
    font-size: 18px;
    color: #404248;
    font-weight: bold;
    margin-bottom: 20px;
    // &:before{
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     content: '';
    //     width: 5.000016px;
    //     height: 27.999984px;
    //     background-color: #4ED6F7;
    //     border-radius: 2.000016px;
    // }
    strong {
      display: block;
      margin-top: 8.000016px;
      font-size: 24px;
      color: #e7816e;
    }
  }
  .item_chart {
    align-items: flex-start;
  }
  .analyse_item_title {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .sanjiao {
      width: 20px;
      height: 12px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/d2820ecc1cfc05cad0a6c8738f892c3f.png)
        no-repeat center center;
      background-size: 100%;
      flex-shrink: 0;
    }
    .analyse_item_title_text {
      font-size: 16px;
      font-weight: bold;
      color: #404248;
      padding: 0 26px;
    }
    .hengxian {
      flex-grow: 1;
      height: 0;
      background: #adb8d9;
    }
  }
  .tree_table_content {
    margin-top: 30px;
    overflow: hidden;
  }
}
.line_chart_container {
  // overflow-y: hidden;
  // overflow-x: scroll;
  padding-bottom: 30px;
  margin-top: 10px;
  position: relative;
  .show_next {
    cursor: pointer;
    position: absolute;
    right: -40px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    div {
      width: 50px;
      height: 311px;
      color: #3f8fff;
      background: #ffffff;
      font-size: 14px;
      // box-shadow: 0px 0px 6.999984px 0px rgba(188, 216, 255, 0.6);
      border: 1px solid #e8edfd;
      border-right: none;
      border-radius: 8px 0 0 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        writing-mode: tb-rl;
        text-orientation: upright;
        letter-spacing: 2.000016px;
      }
    }
  }
}
.level1_label {
  width: 100%;
  padding: 0 90px;
  position: relative;
  margin-top: -25px;
  .label {
    height: 33.999984px;
    font-size: 15.999984px;
    color: #404248;
    line-height: 33.999984px;
    letter-spacing: 9.999984px;
    text-align: center;
  }
}

.contents {
  background: #ffffff;
  border-radius: 4px;
  padding: 20px 50px;
  width: 100%;
  .tab_items {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    position: relative;
    border-radius: 2px;
    overflow: hidden;
    .tab_item {
      width: 185px;
      height: 44px;
      background: #F0F0F0;
      font-size: 14px;
      color: #404248;
      line-height: 44px;
      text-align: center;
      &.active {
        background: #1FBCBF;
        color: #FFFFFF;
      }
    }
  }
}
.add_model_btn {
  cursor: pointer;
  position: absolute;
  left:990px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 100px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #ADADAD;
  display: flex;
  justify-content: center;
  align-items: center;
  .addText {
    font-size: 14px;
    color: #36474F;
    line-height: 21px;
  }
  .addIcon {
    width: 21px;
    height: 21px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/add_20230105.svg) no-repeat;
    margin-right: 11px;
  }
}
.tab_content {
  position: relative;
}
.tree_table_content {
  .model_list_box {
    display: flex;
    align-items: center;
    border: solid 1px #dde5fd;
    border-radius: 4px 4px 0 0;
    border-bottom: none;
    .model_list_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 80px;
      &.model_list_attr {
        font-size: 18px;
        color: #979797;
      }
      .model_attr {
        font-size: 14px;
        color: #979797;
        line-height: 30px;
      }
      .model_name {
        font-size: 14px;
        font-weight: bold;
        color: #474747;
        line-height: 20px;
        padding: 0 5px;
      }
    }
  }
}

.one_evaluation_desc {
  max-width: 600px;
  padding: 0 50px;

  .one_desc_tit {
    height: 70px;
    line-height: 70px;
    font-size: 24px;
    font-weight: bold;
    color: #2b2b2b;
  }
  .one_desc_desc {
    font-size: 18px;
    font-weight: 400;
    color: #777c89;
    line-height: 30px;
  }
}
.more_evaluation_desc {
  padding: 0 10px;
  .table3 {
    border-collapse: collapse;
    td {
      &.table_bd_left {
        border-left: 1px solid #dee6f2;
        &:first-child {
          border: none;
        }
      }
      & > div {
        width: 350px;
        text-align: center;
      }
      .table3_model_name {
        height: 90px;
        font-size: 16px;
        font-weight: bold;
        color: #474747;
        line-height: 24px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .table_title_text {
        height: 32px;
        background: #f5f8fc;
        font-size: 12px;
        font-weight: bold;
        color: #474747;
        line-height: 32px;
      }
      .table3_model_desc {
        padding: 40px 30px 10px;
        font-size: 14px;
        color: #777c89;
        line-height: 20px;
        .table3_model_content {
          text-align: left;
          white-space: pre-line;
        }
        .table3_model_experts,
        .table3_model_time {
          text-align: right;
          margin-top: 12px;
        }
      }
    }
  }
}

.detail_val_text {
  padding: 16px 17px;
  white-space: pre-line;
}
.no_img {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #777c89;
}
.detail_val_pic {
  display: flex;
  align-items: center;
  .detail_pic_left {
    width: 73px;
    height: 80px;
    cursor: pointer;
    .detail_pic_left_img {
      width: 73px;
      height: 60px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  .detail_pic_right {
    font-size: 12px;
    font-weight: bold;
    color: #777c89;
    line-height: 16px;
  }
}
.detail_val_video {
  display: flex;
  align-items: center;
  .detail_video_left {
    width: 92px;
    height: 84px;
    cursor: pointer;
    .detail_pic_left_video {
      width: 92px;
      height: 64px;
      position: relative;
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .look_pic {
      width: 100%;
      height: 16px;
      font-size: 12px;
      color: #5287ea;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.look_pic {
  width: 100%;
  height: 16px;
  font-size: 12px;
  color: #5287ea;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my_swiper_dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .my_swiper_dialog_content {
    width: auto;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .my_swiper_dialog_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png)
        no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      position: absolute;
      top: 40px;
      right: 40px;
      z-index: 2;
      cursor: pointer;
    }
  }
}

.my_dialog {
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
  max-width: 90vw;
  height: calc(100vh - 75px);
  overflow-x: auto;
  overflow-y: auto;
  z-index: 99;
}
.tree_table_score {
  text-align: center;
}
.tree_table_score_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tree_table_score {
    font-size: 12px;
    line-height: 20px;
    .tree_table_score_attr {
      color: #8791b2;
    }
    .tree_table_score_val {
      color: #474747;
    }
  }
  .tree_table_percent {
    font-size: 12px;
    color: #474747;
    line-height: 20px;
  }
}
.level_tag {
  display: inline-block;
  width: 83px;
  height: 18px;
  border-radius: 9px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  margin: 0 10px;
}
.color_E7816E {
  color: #e7816e;
}
.appraise_two_tag,
.detail_tag {
  width: 100%;
  height: 100%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail_table2 {
  border-collapse: collapse;
  tr {
    background: #fff;
    td {
      border: 1px solid #dee6f2;
      text-align: center;
      padding: 10px;
    }
  }

  .table_tit {
    td {
      height: 44px;
    }
  }
  .td_model_info {
    width: 130px;
    .table_model_img {
      width: 100%;
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    .table_model_name {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #474747;
      line-height: 16px;
    }
  }
  .td_node_name {
    width: 100px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_score {
    width: 110px;
    font-size: 12px;
    color: #474747;
    line-height: 20px;
  }
  .td_score_two {
    width: 80px;
    font-size: 12px;
    color: #578ae9;
  }
  .td_node_two {
    width: 105px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_evaluation {
    max-width: 480px;
    text-align: left;
    white-space: pre-line;
    p {
      padding: 10px;
      font-size: 12px;
      color: #777c89;
      line-height: 16px;
    }
  }
}

:deep(.el-table__body-wrapper) {
  overflow-x: hidden;
  overflow-y: hidden;
}
:deep(.el-table__header thead tr th .cell) {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #474747;
}
.has_child_row {
  text-align: center;
}
:deep(.td_class) {
  position: relative;
}
:deep(.td_class .cell) {
  text-align: center;
  font-size: 16px;
  color: #709ae8;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-progress-bar__innerText) {
  color: #000;
}

:deep(.modal_transparent) {
  background: transparent;
}

:deep(.el-drawer__body) {
  overflow-y: auto;
}


.two_level_left{
  width: 130px;
  padding-top: 40px;
  .two_level_item{
    width: 130px;
    height: 44px;
    line-height: 44px;
    background: #F0F0F0;
    text-align: center;
    color:#404248;
    font-size: 12px;
    margin-bottom: 11px;
    cursor:pointer;
    &.act{
      background: #36474F;
      color:#fff;
    }
  }
}
.two_level_right{
  width:950px;
}
</style>